var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 11.5898V3.22266C15.0781 2.89146 14.8117 2.625 14.4805 2.625H6.3125C4.99268 2.625 3.92188 3.6958 3.92188 5.01562V12.9844C3.92188 14.3042 4.99268 15.375 6.3125 15.375H14.4805C14.8117 15.375 15.0781 15.1085 15.0781 14.7773V14.3789C15.0781 14.1921 14.991 14.0228 14.8565 13.9132C14.7519 13.5297 14.7519 12.4365 14.8565 12.053C14.991 11.9459 15.0781 11.7766 15.0781 11.5898ZM7.10938 5.96191C7.10938 5.87974 7.17661 5.8125 7.25879 5.8125H12.5381C12.6203 5.8125 12.6875 5.87974 12.6875 5.96191V6.45996C12.6875 6.54214 12.6203 6.60938 12.5381 6.60938H7.25879C7.17661 6.60938 7.10938 6.54214 7.10938 6.45996V5.96191ZM7.10938 7.55566C7.10938 7.47349 7.17661 7.40625 7.25879 7.40625H12.5381C12.6203 7.40625 12.6875 7.47349 12.6875 7.55566V8.05371C12.6875 8.13589 12.6203 8.20312 12.5381 8.20312H7.25879C7.17661 8.20312 7.10938 8.13589 7.10938 8.05371V7.55566ZM13.4196 13.7812H6.3125C5.87173 13.7812 5.51562 13.4251 5.51562 12.9844C5.51562 12.5461 5.87422 12.1875 6.3125 12.1875H13.4196C13.3723 12.6133 13.3723 13.3554 13.4196 13.7812Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDocsIcon);
export default __webpack_public_path__ + "static/media/api-docs-icon.a7256b69e03268a3eef10d3b4b992720.svg";
export { ForwardRef as ReactComponent };